export default {
  outOfStock: {
    id: 'cart_item_unavailable',
    defaultMessage: 'Item no longer available',
  },
}
